import { StyleSheet } from 'react-native';

import { COLOR, lightGrey } from 'utils/colors';
import {
    androidScreenMarginBottom,
    isTabletOrWeb,
    widthPercentageToDP,
} from 'utils/responsiveness';

const styles = StyleSheet.create({
    dialog: {
        backgroundColor: COLOR.BLACK,
        marginBottom: androidScreenMarginBottom,
    },
    settingsTitleContainer: {
        width: '100%',
        paddingBottom: 12,
        borderBottomWidth: 1,
        borderBottomColor: lightGrey(0.1),
        marginBottom: 20,
    },
    settingsTitle: {
        marginLeft: widthPercentageToDP(72),
        marginRight: 'auto',
    },
    button: { minWidth: isTabletOrWeb ? 120 : widthPercentageToDP(328) },
    whiteButtonText: {
        color: COLOR.WHITE,
    },
    backgroundButtonText: {
        color: COLOR.background,
    },
});

export default styles;
